import { render, staticRenderFns } from "./ProjectTechnical.vue?vue&type=template&id=67067fa5&"
import script from "./ProjectTechnical.vue?vue&type=script&lang=js&"
export * from "./ProjectTechnical.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTechnical.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports